import { AccountGroupDropdownData } from "../../../../Utils/AllPagesQuriesAndMutations";

const data = [
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Upload Image",
        label: "Upload Image",
        Imagefileds: [
          {
            id: Math.random() * 10,
            name: "Cancelled_Cheque",
            label: "Cancelled Cheque",
          },
        ],
      },
    ],
  },
];

const Bank_Fields = [
  {
    name: "Bank_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "BankAccount_Name",
        label: "Bank Account Name",
        type: "text",
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "Bank_Name",
        label: "Bank Name",
        type: "text",
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "Account_Number",
        label: "Account Number",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "IFSC_Code",
        label: "IFSC",
        type: "text",
        min: 11,
        max: 11,
        AllCaps: true,
      },
      {
        id: Math.random() * 10,
        name: "Account_Group",
        label: "Account Group ",
        type: "InputDropForQuery",
        masterName: "Account_Group",
        dropdowndata: AccountGroupDropdownData,
      },
      {
        id: Math.random() * 10,
        name: "Description",
        label: "Description",
        type: "textarea",
        FirstCharCap: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Balance_Method",
      //   label: "Balance_Method",
      //   type: "inputdrop",
      //   dropdowncontent: ["Balance Only", "Bill By Bill"],
      // },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Opening_Balance",
            label: "Opening Balance",
            type: "number",
          },
          {
            id: Math.random() * 10,
            name: "Credit_Or_Debit",
            label: "Cr/Db",
            type: "inputdrop",
            dropdowncontent: ["Cr", "Db"],
          },
        ],
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Cancelled_Cheque",
        label: "Cancelled Cheque",
      },
    ],
  },
];

const Cash_Fields = [
  {
    name: "Cash",
    fields: [
      {
        id: Math.random() * 10,
        name: "BankAccount_Name",
        label: "Account Name",
        type: "text",
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "Account_Group",
        label: "Account Group ",
        type: "InputDropForQuery",
        masterName: "Account_Group",
        dropdowndata: AccountGroupDropdownData,
      },
      {
        id: Math.random() * 10,
        name: "Description",
        label: "Description",
        type: "textarea",
        FirstCharCap: true,
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Cancelled_Cheque",
        label: "Cancelled Cheque",
      },
    ],
  },
];

export const DefaultConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "accountgroups",
        label: "Default Account Group ",
        masterName: "Account_Group",
        type: "InputDropForQuery",
      },
    ],
  },
];

export { data, Bank_Fields, Cash_Fields };
// {
//   id: Math.random() * 10,
//   type: "CardInputFileds",
//   name: "Balance",
//   Subfields: [
//     {
//       id: Math.random() * 10,
//       name: "Balance_Method",
//       label: "Balance_Method",
//       type: "inputdrop",
//       dropdowncontent: ["Balance Only", "Bill By Bill"],
//     },
//   ],
// },
// {
//   id: Math.random() * 10,
//   name: "Sidebyside",
//   Subfields: [
//     {
//       id: Math.random() * 10,
//       name: "Opening_Balance",
//       label: "Opening Balance",
//       type: "number",
//     },
//     {
//       id: Math.random() * 10,
//       name: "Credit_Or_Debit",
//       label: "Cr/Db",
//       type: "inputdrop",
//       dropdowncontent: ["Cr", "Db"],
//     },
//   ],
// },
